import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import ReactPaginate from "react-paginate";

export default function Running() {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

    const [challenge, setchallenge] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [pageNumber, setPageNumber] = useState(0);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [search, setSearch] = useState('');

    const Allchallenge = (page = pageNumber, lim = limit, q = search) => {
        setIsLoading(true);
        const access_token = localStorage.getItem('token')
        const headers = { Authorization: `Bearer ${access_token}` }
        let url = baseUrl + `challange/running_challange?page=${page}&_limit=${lim}`;
        if (q) url += `&_q=${encodeURIComponent(q)}&_stype=Name`;
        axios.get(url, { headers })
            .then((res) => {
                setchallenge(Array.isArray(res.data) ? res.data : (res.data.status || []));
                setTotalPages(res.data.totalPages || 0);
                setPageNumber(page);
                setLimit(lim);
                setSearch(q);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            })
    }

    useEffect(() => {
        Allchallenge(0, limit, '')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const changePage = ({ selected }) => {
        Allchallenge(selected + 1, limit, search);
        window.scrollTo(0, 0);
    };

    const dateFormat = (e) => {
        const date = new Date(e);
        return date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
    }

    // --- STYLES (PURE VISIBILITY) ---
    const tdStyle = { color: '#000000', fontWeight: '700', padding: '15px', textAlign: 'center', borderBottom: '1px solid #eee', background: '#fff' };
    const thStyle = { background: '#f8f9fa', color: '#333', padding: '15px', fontWeight: '800', textAlign: 'center', borderBottom: '2px solid #ddd' };

    return (
        <div style={{ background: '#f0f2f5', minHeight: '100vh', padding: '15px' }}>
            <div style={{ background: '#fff', padding: '20px', borderRadius: '15px', marginBottom: '20px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
                <h4 style={{ margin: 0, color: '#000', fontWeight: '900' }}>Running Challenges</h4>
            </div>

            <div style={{ background: '#fff', padding: '15px 20px', borderRadius: '15px', marginBottom: '20px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
                <input
                    type="text"
                    placeholder="Search by player name..."
                    defaultValue={search}
                    onKeyDown={(e) => { if (e.key === 'Enter') Allchallenge(0, limit, e.target.value); }}
                    style={{ flex: '1 1 220px', padding: '8px 12px', borderRadius: '8px', border: '1px solid #ddd' }}
                />
                <select value={limit} onChange={(e) => Allchallenge(0, e.target.value, search)} style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #ddd' }}>
                    <option value="10">Show 10</option>
                    <option value="20">Show 20</option>
                    <option value="50">Show 50</option>
                    <option value="100">Show 100</option>
                </select>
            </div>

            <div style={{ background: '#fff', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '1000px' }}>
                        <thead>
                            <tr>
                                <th style={thStyle}>#</th>
                                <th style={thStyle}>ID</th>
                                <th style={thStyle}>Creator</th>
                                <th style={thStyle}>Accepter</th>
                                <th style={thStyle}>Amount</th>
                                <th style={thStyle}>Status</th>
                                <th style={thStyle}>Date</th>
                                <th style={thStyle}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr><td colSpan="8" style={{ ...tdStyle, padding: '100px' }}>Loading data...</td></tr>
                            ) : challenge.length > 0 ? (
                                challenge.map((game, index) => (
                                    <tr key={game._id}>
                                        <td style={tdStyle}>{(pageNumber > 0 ? (pageNumber - 1) * limit : 0) + index + 1}</td>
                                        <td style={{ ...tdStyle, color: '#007bff', fontSize: '12px' }}>{game._id}</td>
                                        <td style={tdStyle}>{game.Created_by?.Name || '---'}</td>
                                        <td style={tdStyle}>{game.Accepetd_By?.Name || '---'}</td>
                                        <td style={{ ...tdStyle, color: '#28a745' }}>₹{game.Game_Ammount}</td>
                                        <td style={tdStyle}>
                                            <span style={{ background: '#e7f3ff', color: '#007bff', padding: '4px 10px', borderRadius: '4px', fontSize: '11px' }}>{game.Status}</span>
                                        </td>
                                        <td style={{ ...tdStyle, fontSize: '11px', color: '#666' }}>{dateFormat(game.createdAt)}</td>
                                        <td style={tdStyle}>
                                            <Link to={`/view/${game._id}`} style={{ background: '#000', color: '#fff', padding: '6px 12px', borderRadius: '6px', textDecoration: 'none', fontSize: '12px' }}>View</Link>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="8" style={{ ...tdStyle, padding: '100px' }}>No Running Challenges Found</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination UI */}
            {totalPages > 1 && (
                <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center' }}>
                    <style>{`
                        .pagination { display: flex; list-style: none; gap: 5px; }
                        .page-item { border: 1px solid #ddd; border-radius: 8px; background: #fff; }
                        .page-link { padding: 10px 15px; color: #000; cursor: pointer; display: block; font-weight: bold; text-decoration: none; }
                        .pagination .active { background: #000 !important; color: #fff !important; border-color: #000; }
                        .pagination .active a { color: #fff !important; }
                    `}</style>
                    <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        pageCount={totalPages}
                        onPageChange={changePage}
                        forcePage={pageNumber > 0 ? pageNumber - 1 : 0}
                        containerClassName={"pagination"}
                        activeClassName={"active"}
                    />
                </div>
            )}
        </div>
    )
}
